export default "__VITE_ASSET__4DMqm7$E__"